import thinkingdata from 'thinkingdata-browser'

import Client from '@/commonFunc/client.js'
import Request from '@/utils/request.js'
import SecretKey from '@/config/secret-key.js'
import BaseConfig from '@/config/base.js'

import { getTraceStore } from '@/utils/storage.js'
import { decryptCode } from '@/utils/common.js'
import { flushTaPageViewQueue } from '@/utils/ta-page-view.js'
import { getLandingTrafficSuperProps } from '@/utils/landing-traffic.js'

function initThinkingData(jsonObj) {
  if (!jsonObj || !jsonObj.appId || !jsonObj.url) {
    return
  }
  window.ta = thinkingdata
  window.ta.init({
    appId: jsonObj.appId || '',
    serverUrl: jsonObj.url || '',
    // 缓存>批量发送
    batch: false,
    autoTrack: {
      pageShow: false,
      pageHide: false,
    },
    // mode: "debug"
  })

  const uid = Client.getUserBaseInfo().uid

  ta.login(uid || '')
  let landingSuperProps = {}
  try {
    landingSuperProps = getLandingTrafficSuperProps()
  } catch (e) {
    console.log('getLandingTrafficSuperProps', e)
  }
  window.ta.setSuperProperties({
    channel: Client.getAppInfo().channel || '',
    ...landingSuperProps,
  })

  flushTaPageViewQueue()

  if (uid && window.ta) {
    const sotreTraceArr = getTraceStore(`thinkingdata_${uid}`)
    if (Array.isArray(sotreTraceArr)) {
      // 清理缓存
      window.localStorage.removeItem(`thinkingdata_${uid}`)
      // 上报数数
      sotreTraceArr.forEach((item) => {
        window.ta.track('h5_page_track', item)
      })
    }
  }
}

try {
  const isLogin = !!Client.getUserBaseInfo().uid
  if (BaseConfig.isRelease) {
    const isApp = Client.env.isApp
    const req =
      isApp && isLogin
        ? Request({ url: '/api/v2/comm/aws/key?type=1', method: 'get', envelope: false })
        : Request({ url: '/api/v2/comm/ss/key', method: 'get', envelope: false })

    req.then((resData) => {
      initThinkingData(JSON.parse(decryptCode(resData, SecretKey.pk)))
    })
  }
} catch (err) {
  console.log('try catch', err)
}
